export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V případě, že zapomenete heslo pro přístup k účtu, můžete jej obnovit odpovědí na tajnou otázku."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V této sekci můžete změnit tajnou otázku/odpověď."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tajná otázka"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaše otázka:"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odpověď:"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tajná otázka"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vlastní otázka"])}
}